/* Giclee frame-pricing lookup. Mirrors LPO's per-frame price-compute JS
   (LPO doesn't expose that compute through its customer API, so we
   replicate it here). Source of truth: Context/data/frame-pricing.md.
   If Brendan changes the LPO frame compute, update both. */
(function (w) {
  // [effW_max, effL_max, standard, premium]. Last row is the fallback.
  var TIERS = [
    [ 8, 10,  60,   80],
    [11, 14,  83,  125],
    [16, 20, 120,  180],
    [18, 24, 140,  210],
    [20, 30, 166,  250],
    [24, 36, 200,  300],
    [30, 40, 233,  400],
    [40, 50, 300,  550],
    [40, 60, 500,  833],
    [44, 60, 520,  866],
    [50, 60, 550,  916],
    [60, 80, 700, 1166]
  ];
  var FALLBACK = [700, 1166];

  function matOffset(v) {
    if (v === 'Window-Matte-1.5' || v === 'Float-With-1.5') return 3;
    if (v === 'Window-Matte-2') return 4;
    return 0;
  }

  function groupOf(frameValue) {
    if (!frameValue) return null;
    if (/-Premium$/i.test(frameValue))  return 'premium';
    if (/-Standard$/i.test(frameValue)) return 'standard';
    return null;
  }

  function priceFor(frameValue, opts) {
    var grp = groupOf(frameValue);
    if (!grp) return null;
    var x = parseFloat((opts && opts.x) || 0);
    var y = parseFloat((opts && opts.y) || 0);
    var b = parseFloat((opts && opts.border) || 0);
    var off = matOffset(opts && opts.addlFrameOption);
    if (!(x > 0) || !(y > 0)) return null;
    var smaller = x < y ? x : y;
    var larger  = x < y ? y : x;
    var effW = smaller + 2 * b + off;
    var effL = larger  + 2 * b + off;
    var col = grp === 'premium' ? 3 : 2;
    for (var i = 0; i < TIERS.length; i++) {
      if (effW <= TIERS[i][0] && effL <= TIERS[i][1]) return TIERS[i][col];
    }
    return grp === 'premium' ? FALLBACK[1] : FALLBACK[0];
  }

  w.GicleeFramePricing = {
    priceFor: priceFor,
    matOffset: matOffset,
    groupOf: groupOf
  };
})(window);
